import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/cross.svg'
import _imports_1 from '@/assets/img/chevron-right.svg'


const _withScopeId = n => (_pushScopeId("data-v-2f4385e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "opModal uploadCertificationModal formContainer" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "body" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "d-flex align-items-center fw_700" }
const _hoisted_9 = { class: "fs_12 mt-1" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$filters.date(_ctx.selectedDate, "DD.MM.YYYY")), 1),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-modal-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.certifications, (cert, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "card",
          onClick: ($event: any) => (_ctx.goToProviderCertifications(cert.provider.identifier))
        }, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_localized_text, {
                localizedKey: "In scadenza:",
                text: "In scadenza:",
                class: "me-1"
              }),
              _createTextVNode(" " + _toDisplayString(cert.certificationName), 1)
            ]),
            _createElementVNode("div", _hoisted_9, _toDisplayString(cert.provider.text), 1)
          ]),
          _hoisted_10
        ], 8, _hoisted_7))
      }), 256))
    ])
  ]))
}